<script>
export default {
  name: 'FirebaseUserDetailView',
  data: () => ({
    user: {},
    isLoading: false,
    form: {
      email: '',
      phoneNumber: '',
    },
    errors: {},
  }),
  computed: {
    customer() {
      return this.user.customer || {}
    },
  },
  async created() {
    try {
      this.isLoading = true
      this.user = await this.$api.firebaseUsers(this.$route.params.uid).get()
      this.form.email = this.user.email
      this.form.phoneNumber = this.user.phoneNumber
    } catch (err) {
      console.error(err)
    }
    this.isLoading = false
  },
  methods: {
    async update() {
      try {
        this.isLoading = true
        await this.$api.firebaseUsers(this.$route.params.uid).update(this.form)
        this.$toast.success(
          this.$t('firebaseUser.detail.message.updateSuccess')
        )
      } catch (err) {
        console.error(err)
        this.errors = err.response.data.errors
        this.$toast.error(this.$t('firebaseUser.detail.message.updateFailed'))
      }
      this.isLoading = false
    },
  },
}
</script>

<template>
  <v-container>
    <v-text-field
      v-model="form.email"
      :label="$t('firebaseUser.text.firebaseEmail')"
      outlined
    />
    <v-text-field
      v-model="form.phoneNumber"
      :label="$t('firebaseUser.text.firebasePhoneNumber')"
      outlined
    />
    <v-btn color="primary" :loading="isLoading" @click="update">{{
      $t('firebaseUser.button.update')
    }}</v-btn>

    <v-simple-table>
      <tbody>
        <tr>
          <th>{{ $t('firebaseUser.text.uid') }}</th>
          <td v-text="user.uid" />
        </tr>
        <tr>
          <th>{{ $t('firebaseUser.text.email') }}</th>
          <td v-text="user.email" />
        </tr>
        <tr>
          <th>{{ $t('firebaseUser.text.phoneNumber') }}</th>
          <td v-text="user.phoneNumber" />
        </tr>
        <tr>
          <th>{{ $t('firebaseUser.text.familyName') }}</th>
          <td v-text="user.familyName" />
        </tr>
        <tr>
          <th>{{ $t('firebaseUser.text.givenName') }}</th>
          <td v-text="user.firstName" />
        </tr>
        <tr v-if="$i18n.locale === 'ja'">
          <th>{{ $t('firebaseUser.text.familyNameKana') }}</th>
          <td v-text="user.familyNameKana" />
        </tr>
        <tr v-if="$i18n.locale === 'ja'">
          <th>{{ $t('firebaseUser.text.givenNameKana') }}</th>
          <td v-text="user.firstNameKana" />
        </tr>
      </tbody>
    </v-simple-table>

    <h2>{{ $t('firebaseUser.text.customer') }}</h2>
    <v-simple-table>
      <tbody>
        <tr>
          <th>{{ $t('firebaseUser.text.id') }}</th>
          <td v-text="customer.uuid" />
        </tr>
        <tr>
          <th>{{ $t('firebaseUser.text.memberNumber') }}</th>
          <td v-text="customer.account" />
        </tr>
        <tr>
          <th>{{ $t('firebaseUser.text.shop') }}</th>
          <td v-text="customer.shopName" />
        </tr>
        <tr>
          <th>{{ $t('firebaseUser.text.familyName') }}</th>
          <td v-text="user.familyName" />
        </tr>
        <tr>
          <th>{{ $t('firebaseUser.text.givenName') }}</th>
          <td v-text="user.firstName" />
        </tr>
        <tr v-if="$i18n.locale === 'ja'">
          <th>{{ $t('firebaseUser.text.familyNameKana') }}</th>
          <td v-text="user.familyNameKana" />
        </tr>
        <tr v-if="$i18n.locale === 'ja'">
          <th>{{ $t('firebaseUser.text.givenNameKana') }}</th>
          <td v-text="user.firstNameKana" />
        </tr>
      </tbody>
    </v-simple-table>
  </v-container>
</template>
